module.exports = __webpack_public_path__ + "static/crypto-unlocked-244d5238e6576347b4228ed53b0b600a.png";